export default __webpack_public_path__ + "static/symbol-logo-42e7596830ee33dd5f59f9d9d5c07116.svg";